/**
 * ImgZoomModel.ts
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 이미지 팝업의 확대 축소를 제어합니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

import { makeAutoObservable } from 'mobx';

export default class ImgZoomModel {
  public isZoom: boolean;
  public x: number;
  public y: number;

  // 이전 드래그 좌표
  private px: number;
  private py: number;

  constructor() {
    this.isZoom = false;
    this.x = 0;
    this.y = 0;
    this.px = 0;
    this.py = 0;

    // this.loadStatus = 'READY';
    makeAutoObservable(this);
  }

  setIsZoom = (isZoom: boolean) => {
    this.isZoom = isZoom;
  };

  // 좌표 초기화
  setInit = () => {
    this.x = this.y = this.px = this.py = 0;
  };

  // 좌표 동기화
  setSync = () => {
    this.px = this.x;
    this.py = this.y;
  };

  setIsMousePosition = (x: number, y: number) => {
    this.px = this.x;
    this.px = this.y;

    this.x = x;
    this.y = y;
  };

  // 마지막으로 드래그가 이뤄졌는지 여부
  isLastDrag = () => {
    return this.x != this.px || this.y != this.py;
  };
}
